// ✅ Trekkin.app — PanelResetPassword.jsx v2.0.0 FINAL
// -------------------------------------------------------------
// 🔹 Usa resetPassword() do useAuthStore v6.5.0
// 🔹 Fecha painel automaticamente após sucesso
// -------------------------------------------------------------

import { useState } from "react";
import { useAuthStore } from "../stores/useAuthStore";
import { usePanelsStore } from "../stores/usePanelsStore";
import { useTranslate } from "../i18n/useTranslate";

const base = import.meta.env.BASE_URL || "/";
const logoSrc = `${base}logo-trekkin.png`;

export default function PanelResetPassword() {
  const resetPassword = useAuthStore((s) => s.resetPassword);
  const { closePanel } = usePanelsStore();
  const translate = useTranslate();

  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setMsg("");

    const trimmed = email.trim().toLowerCase();
    if (!trimmed) {
      setMsg(translate("forgot.toast.invalidEmail"));
      return;
    }

    setLoading(true);

    const result = await resetPassword(trimmed);

    if (result?.ok) {
      setMsg(translate("forgot.toast.sent"));
      setTimeout(() => closePanel(), 1200);
    } else {
      setMsg(result?.error || translate("forgot.toast.error"));
    }

    setLoading(false);
  }

  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
      <form
        onSubmit={handleSubmit}
        style={{
          background: "rgba(255,255,255,0.96)",
          borderRadius: 12,
          padding: 22,
          boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          maxWidth: 420,
          gap: 12,
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 6 }}>
          <img
            src={logoSrc}
            style={{
              width: 108,
              marginBottom: 10,
              filter: "drop-shadow(0 3px 8px rgba(0,0,0,0.35)) brightness(1.02)",
            }}
          />

          <h2 style={{ margin: 0, fontSize: 18 }}>{translate("forgot.title")}</h2>
          <p style={{ fontSize: 14, marginTop: 6, color: "#444" }}>
            {translate("forgot.description")}
          </p>
        </div>

        <input
          type="email"
          placeholder={translate("forgot.placeholderEmail")}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{
            padding: "0.55rem 0.9rem",
            borderRadius: 8,
            border: "1px solid #d1d5db",
            fontSize: 15,
          }}
        />

        <button
          type="submit"
          disabled={loading}
          style={{
            padding: "0.7rem 1rem",
            borderRadius: 8,
            background: "#28a745",
            border: "none",
            color: "#fff",
            fontWeight: 600,
            fontSize: 15,
            cursor: "pointer",
            opacity: loading ? 0.7 : 1,
          }}
        >
          {loading ? translate("forgot.sending") : translate("forgot.sendLink")}
        </button>

        {msg && (
          <p
            style={{
              textAlign: "center",
              marginTop: 2,
              fontSize: 14,
              color:
                msg.startsWith("📩") || msg.startsWith("✅")
                  ? "#15803d"
                  : "#b91c1c",
            }}
          >
            {msg}
          </p>
        )}
      </form>
    </div>
  );
}
